import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { LessonType } from "../types";

function Layout({ lessons }: { lessons: LessonType[] }) {
  const [sidenav, setSidenav] = useState<M.Sidenav[] | null>(null);

  function openSideNav() {
    if (sidenav) sidenav[0].open();
  }

  useEffect(() => {
    const sidenavs = document.querySelectorAll(".sidenav");
    const sidenavInstance = M.Sidenav.init(sidenavs, {});
    setSidenav(sidenavInstance);
  }, []);

  return (
    <div>
      <div className="row">
        <nav className="nav-extended">
          <div className="nav-wrapper left-padding">
            <a className="brand-logo center">Passive German</a>
            <ul className="left">
              <li>
                <a onClick={openSideNav}>
                  <i className="material-icons">menu</i>
                </a>
              </li>
            </ul>
            {!isNaN(Number(window.location.pathname[7])) &&
              Number(window.location.pathname[7]) < lessons.length && (
                <ul className="right">
                  <li
                    className="tooltipped"
                    data-position="left"
                    data-tooltip="Vocabulary"
                  >
                    <a href="#vocab-modal" className="modal-trigger">
                      <i className="material-icons">import_contacts</i>
                    </a>
                  </li>
                </ul>
              )}
          </div>
        </nav>
      </div>
      <div className="row">
        <ul className="sidenav" id="slide-out">
          {lessons.map((_, idx, arr) => (
            <li>
              <a href={`/lesson${idx + 1}`}>{`Lesson ${idx + 1}`}</a>
            </li>
          ))}
        </ul>
      </div>
      <Outlet />
    </div>
  );
}

export default Layout;
